<template lang="pug">
    v-dialog(v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition" )
        template
            v-toolbar(dark dense color="red" class="navFixed")
                v-toolbar-title i-Permit Preview
                v-spacer
                v-toolbar-items
                    v-btn(@click="ip.permit.ipStatus == 4 || ip.permit.ipStatus == 8 ? print = true : printIP(ip.permit._id)" color="red" depressed title="Print" )
                        v-icon print
                        | &nbsp; Print
                        v-dialog(v-model="print" persistent max-width="400px")
                            v-card
                                v-card-title(class="headline grey lighten-3") Print Document
                                v-alert(:value='true' color="success")
                                    h3(style="text-align: center; font-weight:normal; color: white;") To save the trees, please think to share it rather than print.
                                v-flex(class="headline grey lighten-3")
                                    v-row(no-gutters align="center" justify="center")
                                        v-btn(@click="printIP(ip.permit._id); print = false;" class="ma-3 pa-3 red darken-2" style="border-radius: 10px; box-shadow: -2px 4px #888888;")
                                            i(class="far fah fa-lg fa fa-print" style="color:white")
                                            span(class="ma-3" style="color:white") Print
                                        v-btn(@click="print = false; shareIP();" class="ma-3 pa-3 green" style="border-radius: 10px; box-shadow: -2px 4px #888888;")
                                            i(class="far fah fa-lg fa fa-share-alt" style="color:white")
                                            span(class="ma-3" style="color:white") Share
                                v-spacer
                                v-flex(class="text-end headline grey lighten-2")
                                    v-btn(color="blue darken-1" text @click.native="print = false") Close
                    v-btn(@click.native="handleClose" color="red" depressed)
                        v-icon(title="Close") cancel
                        | &nbsp; Close
            v-list(class="print-bg padTop60")
                div(:id="ip.permit._id")
                    .page(size="Auto" style="height:auto")
                        div(class="view-width" style="font-size:10px;")
                            table(class="view-width tableInput" )
                                tbody
                                    tr
                                        td( class="align-center" width="150" rowspan="3")
                                            img(class="verMiddle" src="../assets/BORNEO-INDOBARA.jpg" width="120px")
                                        td(class="align-center") SINARMAS MINING SYSTEM
                                        td( class="align-center" width="150" rowspan="3") 
                                            img(class="verMiddle" :src="`${API_URL}/qr/generate-induksi-qr?ktpVisitor=${dataRowVisitor.ktp}&permitId=${dataRequestPermit._id}`" style="width:80px;margin:2px 0;")
                                    tr
                                        td(class="align-center") FORMULIR
                                    tr
                                        td(class="align-center") {{ formName[dataRequestPermit.ipForm] }}
                            table( class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                                tbody
                                    tr
                                        td(class="headerTable" colspan="6" style="text-align:center; padding:2px; font-size:16px; font-weight:bold") INDUKSI KESELAMATAN PENGUNJUNG
                            table( class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                                tbody
                                    tr
                                        td(style="border:none; padding:4px 4px 0px 4px; font-size:11px") Pimpinan PT BORNEO INDOBARA percaya bahwa semua orang mempunyai hak dan kewajiban untuk bekerja dengan aman dan sehat di area kerja perusahaan termasuk para pengunjung. Kami bertanggung jawab sepenuhnya untuk menjaga kesehatan dan keselamatan pengunjung selama berada di area kerja perusahaan, tetapi kami mengharapkan pengunjung kami untuk memnerima tanggung jawab keselamatan personal mereka secara baik.
                            table( class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                                tbody
                                    tr
                                        td(style="border:none; padding:0px 4px 4px 4px; font-size:11px; font-style:italic;text-align:justify;font-size:13px; color:#006E9F;") PT BORNEO INDOBARA management believes that every personnel have the rights and duties to work safety and healthy in our work area and this includes to visitors. We accept the responsibilities to protect our visitors from any safety and health incident in our work area but we urge every visitor to understand and ensure of their own personal safety as well.
                            table( class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                                tbody
                                    tr
                                        td(class="headerTable"  style="text-align:center; padding:4px; font-weight: bold;font-size:11px;border-bottom:none") Berikut Peraturan untuk keselamatan pengunjung yang harus dipatuhi selama kunjungan berlangsung :
                                    tr
                                        td(class="headerTable"  style="text-align:center; padding:0px 4px 4px 4px; font-weight: bold;font-size:11px;border-top:none;border-bottom:none") silahkan diberi tanda (✓  pada box ☐) jika telah memahami     
                                    tr
                                        td(class="headerTable"  style="text-align:center; padding:0px 4px 4px 4px; font-weight: bold;font-size:11px;border-top:none;border-bottom:none;color:#006E9F;") Below the sefety for visitors must be obey, Giveacheck sign (✓ in box) if you understood the rules
                            table( class="view-width tableInput autoPageBreak")
                                tbody
                                    tr
                                        td(width="30px" class="align-center")
                                            img(v-if="dataRowVisitor.inductionAnswers[0]" class="verMiddle" src="../assets/check.png" width="10")
                                            v-flex(v-else) 
                                        td(width="200px" style="font-size:11px") 1. Permit from Technical Mine Manager (KTT) 
                                        td(width="200px" style="font-size:11px") Rencana kunjungan (Tamu) sudah diterima oleh pihak perusahaan dan disetujui oleh KTT            
                                    tr
                                        td(width="30px" class="align-center")
                                            img(v-if="dataRowVisitor.inductionAnswers[1]" class="verMiddle" src="../assets/check.png" width="10")
                                            v-flex(v-else) 
                                        td(width="200px" style="font-size:11px") 2. You shall left ID Card to Security and get ID visitor must use at all times.
                                        td(width="200px" style="font-size:11px") Pengunjung harus menukarkan kartu identitas pribadi di pos keamanan untuk mendapat kartu tamu (Visitor) yang akan digunakan selama kunjungan
                                    tr
                                        td(width="30px" class="align-center")
                                            img(v-if="dataRowVisitor.inductionAnswers[2]" class="verMiddle" src="../assets/check.png" width="10")
                                            v-flex(v-else) 
                                        td(width="200px" style="font-size:11px") 3. You must be fit to work 
                                        td(width="200px" style="font-size:11px") Pengunjung harus dalam keadaan sehat untuk melakukan kunjungan (Istirahat yang cukup)
                                    tr
                                        td(width="30px" class="align-center")
                                            img(v-if="dataRowVisitor.inductionAnswers[3]" class="verMiddle" src="../assets/check.png" width="10")
                                            v-flex(v-else) 
                                        td(width="200px" style="font-size:11px") 4. You must be escorted by an appointed company's representative all times
                                        td(width="200px" style="font-size:11px") Pengunjung wajib didampingi oleh perwakilan perusahaan/departemen kustodian selama kunjungan berlangsung
                                    tr
                                        td(width="30px" class="align-center")
                                            img(v-if="dataRowVisitor.inductionAnswers[4]" class="verMiddle" src="../assets/check.png" width="10")
                                            v-flex(v-else) 
                                        td(width="200px" style="font-size:11px") 5. You must obey all safety instruction
                                        td(width="200px" style="font-size:11px") Pengunjung harus mematuhi semua instruksi keselamatan yang telah diberikan oleh perwakilan perusahaan
                                    tr
                                        td(width="30px" class="align-center")
                                            img(v-if="dataRowVisitor.inductionAnswers[5]" class="verMiddle" src="../assets/check.png" width="10")
                                            v-flex(v-else) 
                                        td(width="200px" style="font-size:11px") 6. You must be wearing all protective personal equipment as required 
                                        td(width="200px" style="font-size:11px") Pengunjung harus menggunakan semua APD alat pelindung diri yang dipersyaratkan untuk suatu area kerja
                                    tr
                                        td(width="30px" class="align-center")
                                            img(v-if="dataRowVisitor.inductionAnswers[6]" class="verMiddle" src="../assets/check.png" width="10")
                                            v-flex(v-else) 
                                        td(width="200px" style="font-size:11px") 7. No physical activity except observation, audit and data collection
                                        td(width="200px" style="font-size:11px") Pengunjung tidak diizinkan melakukan kegiatan fisik selain observasi, audit dan pengambilan data
                                    tr
                                        td(width="30px" class="align-center")
                                            img(v-if="dataRowVisitor.inductionAnswers[7]" class="verMiddle" src="../assets/check.png" width="10")
                                            v-flex(v-else) 
                                        td(width="200px" style="font-size:11px") 8. Do not operate vehicle or unit without authority
                                        td(width="200px" style="font-size:11px") Pengunjung tidak diizinkan mengoperasikan kendaraan/unit apapun kecuali telah mengikuti induksi/test khusus
                                    tr
                                        td(width="30px" class="align-center")
                                            img(v-if="dataRowVisitor.inductionAnswers[8]" class="verMiddle" src="../assets/check.png" width="10")
                                            v-flex(v-else) 
                                        td(width="200px" style="font-size:11px") 9. Do not litter 
                                        td(width="200px" style="font-size:11px") Pengunjung harus menjaga diri agar tidak membuang sampah selain pada tempat yang telah disiapkan
                                    tr
                                        td(width="30px" class="align-center")
                                            img(v-if="dataRowVisitor.inductionAnswers[9]" class="verMiddle" src="../assets/check.png" width="10")
                                            v-flex(v-else) 
                                        td(width="200px" style="font-size:11px") 10. Obey no smoking and no fire area.
                                        td(width="200px" style="font-size:11px") Pengunjung harus menjaga diri untuk tidak merokok atau membuat api pada daerah yang ditetapkan
                                    tr
                                        td(width="30px" class="align-center")
                                            img(v-if="dataRowVisitor.inductionAnswers[10]" class="verMiddle" src="../assets/check.png" width="10")
                                            v-flex(v-else) 
                                        td(width="200px" style="font-size:11px") 11. Report any hazard and incident to your escorter or the HSE Call Centre
                                        td(width="200px" style="font-size:11px") Pengunjung harus segera melaporkan adanya bahaya atau insiden kepada pendampingnya atau ke HSE Centre
                                    tr
                                        td(width="30px" class="align-center")
                                            img(v-if="dataRowVisitor.inductionAnswers[11]" class="verMiddle" src="../assets/check.png" width="10")
                                            v-flex(v-else) 
                                        td(width="200px" style="font-size:11px") 12. Evacuate yourself to the muster point when emergency 
                                        td(width="200px" style="font-size:11px") Pengunjung harus segera evakuasi diri ke titik kumpul darurat jika terjadi keadaan darurat dalam kunjungan
                                    tr
                                        td(width="30px" class="align-center")
                                            img(v-if="dataRowVisitor.inductionAnswers[12]" class="verMiddle" src="../assets/check.png" width="10")
                                            v-flex(v-else) 
                                        td(width="200px" style="font-size:11px") 13. Keep the Emergency call centre's number 0812 5109 555 while you are inside PT. Borneo Indobara work area. Say "EMERGENCY" 3x followed by your Name & Location, to get immediate help 
                                        td(width="200px" style="font-size:11px") Simpan nomor HSE Centre 0812 5109 555 untuk melaporkan bahaya, insiden atau situasi darurat. (Sebutkan DARURAT 3x Nama & Lokasi)
                            
                            table( class="view-width tableInput autoPageBreak" style="margin-top:10px")
                                tbody
                                    tr
                                        td(class="headerTable" style="width:75%; padding:6px; font-size:11px;border-right:none;font-weight:bold") Identitas Pengunjung
                                        td(class="headerTable" style="width:25%; padding:6px; font-size:11px;border-left:none;font-weight:bold") No Kartu Visitor : 
                            table(class="view-width autoPageBreak tableInput")
                                tbody
                                    tr
                                        td(width="30%" style="padding-top:0px;font-size:11px" ) Nama Lengkap
                                        td(width="40%" style="padding-top:0px;font-size:11px") {{dataRowVisitor.name}}
                                        td(style="padding-top:0px;font-size:11px;") Golongan Darah : {{dataRowVisitor.bloodType}}
                                    tr
                                        td(width="30%" style="padding-top:0px;font-size:11px" ) Institusi / Organisasi
                                        td(style="padding-top:0px;font-size:11px" colspan="2") {{dataRowVisitor.company}}
                                    tr
                                        td(width="30%" style="padding-top:0px;font-size:11px" ) Tujuan Berkunjung
                                        td( style="padding-top:0px;font-size:11px" colspan="2") {{dataRequestPermit.ipTujuanKunjungan}}
                                    tr
                                        td(width="30%" style="padding-top:0px;font-size:11px" ) Lama berkunjung dari tanggal
                                        td(style="padding-top:0px;font-size:11px") {{dayjs(dataRequestPermit.ipTanggalKunjungan).format(dateFormat)}}
                                        td(style="padding-top:0px;font-size:11px") Ke Tanggal : {{dayjs(dataRequestPermit.ipSelesaiKunjungan).format(dateFormat)}}
                                    tr
                                        td(width="30%" style="padding-top:0px;font-size:11px" ) Kontak darurat orang terdekat
                                        td( style="padding-top:0px;font-size:11px" colspan="11") {{dataRowVisitor.emergencyPhone}}
                                    tr
                                        td(width="30%" style="padding-top:0px;font-size:11px" ) Nomer Permit
                                        td( style="padding-top:0px;font-size:11px" colspan="11") {{dataRequestPermit.ipNo}}
                                    tr
                                        td(width="30%" style="padding-top:0px;font-size:11px" ) Nama Pendamping (BIB)
                                        td(style="padding-top:0px;font-size:11px") {{dataRequestPermit.ipPemegangIzin.name}}
                                        td(style="padding-top:0px;font-size:11px") 
                                    tr
                                        td(width="30%" style="padding-top:0px;font-size:11px" ) Tanda Tangan
                                        td(style="padding-top:0px;font-size:11px") 
                                          div(style="padding:10px")
                                            img(src="../assets/check-64.png" style="width:50px;")
                                            p(style="margin-bottom:-5px") Pengunjung
                                        td(style="padding-top:0px;font-size:11px")
                                          div(style="padding:10px")
                                            img(src="../assets/check-64.png" style="width:50px;")
                                            p(style="margin-bottom:-5px") Pendamping (BIB)
</template>

<script>
// import axios from 'axios';
import * as config from "../config/index.json";
import { mapState } from 'vuex';
import printJS from 'print-js';
import dayJS from "dayjs";
import helper from "../helper/index.js";
export default {
  name: 'InduksiView',
  props:["dialogType","ip","approvalUser","dataRequestPermit","dialog","dataRowVisitor"],
  data: () => ({
    formName: config.FormName,
    config: config.default,
    regex: /\//gi,
    approvalDialog: false,
    approvalDialog2: false,
    comment: '',
    ipPengesahanApproval : null,
    ipClosingResubmitted : null,
    ipClosingSubmitted : null,
    ipDocPengesahan : null,
    approval: null,
    share: false,
    print: false
  }),
  computed: {
    ...mapState(['API_URL', "networks", "sharing", "shortenUrl","dateFormat"]),
    locations(){
        let temp = []
        for (const index in this.ip.ipLocation) {
            temp.push(this.ip.ipLocation[index].name)
        }
        return temp
    },
  },
  mounted() {
    // console.log(this.ip)
    // console.log(this.dataRowVisitor)
    // console.log(this.dialog)
    },
methods: {
    download(file) {
        this.$downloadFile(file);
    },
    shareIP() {
        this.$store.dispatch("getShortenUrl", {ip: this.ip, 
        approvalUser: this.approvalUser, context: this.share}).then(() => {
            this.share = true;
        });
    },
    handleClose(){
        this.$emit('closeModal', false)
    },
    printIP(id){
        printJS({
            printable: id, 
            type: 'html',
            scanStyles: false,
            css: ["/stylesheets/main.css" ,"/stylesheets/approval.css", "/stylesheets/vuetify.min.css",  '/stylesheets/view.css', "/stylesheets/ck-content.css"]
        });
    },
    dayjs(val = undefined) {
      return dayJS(val);
    },
    formatDate: helper.formatDateOnly,
    approvalTime(date){
        return new Date(date).toLocaleString('en-GB');
    }
  },
  watch: {
    // dataRequestPermit(param){
    //     console.log(param)
    // },
    // dataRowVisitor(param){
    //     console.log(param)
    // }
  }
};
</script>
<style scoped>
.print-bg {
  background: rgb(204,204,204);
  padding-top: 10px;
}
.print-bg > div{
  text-align:center;
}
.page {
  background: white;
  display: block;
  margin: 5px auto;
  padding: 0.7cm 1cm 0.8cm;
  position: relative;
}
.page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}
.page[size="Auto"] {
  width: auto;
  margin:0 auto;
  display:inline-block;
  text-align:initial;
}
.view-width {
  width: 19cm;
}
.print-header {
  border-collapse: collapse;
  text-align: right;
}
.padding-x-3 {
  padding:0 3px;
}
.padding-xy-5 {
  padding:2px;
}
.padding-xy-1 {
  padding:1px;
}
.margin-tl-5 {
  margin: 3px 5px 0 5px;
}
.margin-tl-10 {
  margin: 3px 10px 0 10px;
}
.margin-tl-25 {
  margin: 3px 15px 0 25px;
}
.logo-cell {
  padding:8px 5px 0px;
  width:35%;
}
.detail-wrap {
  margin-top: 5px;
}
.border-left-0 {
  border-left: 0;
}
.border-right-0 {
  border-right: 0;
}
.approved {
  text-align: center;
  padding:5px;
}
.ff0000 {
  color: #ff0000;
}
.align-center {
  text-align: center;
}
.align-left {
 align-items: left;
}
.width-20p {
  width:20%;
}
.width-25p {
  width:25%;
}
.height-40px {
  height: 40px;
}
.width-300px {
  width: 250px;
}
.top-align {
  vertical-align:top;
}
.navFixed {
  position: fixed;
  z-index: 9;
}
.padTop60 {
  padding-top:60px;
}
.blink {
	-webkit-animation: blink 2s steps(5, start) infinite;
  animation: blink 2s steps(5, start) infinite;
  color: #dddddd;
}
@-webkit-keyframes blink { to { color: #ffffff; }}
@keyframes blink { to { color: #ffffff; }}
@media print {
    
}
table {
  border-collapse: collapse;
}

.headerTable{
    border: 1px solid black; 
    background-color: #cccccc;
}
.tableInput td{
    border: 1px solid black;
    padding-left: 5px;
}
.verMiddle{
    vertical-align:middle;
}
.comment{
    word-break: break-all;
}
.tableCollapse td{
    border: 1px solid #DDDDDD;
    border-top: 0;
    padding-left: 5px;
}
.emptySign {
    width:25px;
}
#background {
  position:absolute;
  z-index:0;
  display:block;
  top:150px;
  left:0px;
  text-align: center;
  width: 100%;
}
.imgWatermark {
  width: 650px;
  position:absolute;
  top:0px;
  right:50px;
  opacity: 0.65;
}
.fontWatermarkUp {
  font-size:450%; 
  position:absolute;
  transform: rotate(-30deg);
  opacity: 0.65;  
  right: 200px;
  color: rgb(224,224,224);
}
.fontWatermarkDown {
  font-size:450%; 
  position:absolute;
  transform: rotate(-30deg);
  opacity: 0.65;  
  top: 450px;
  right: 100px;
  color: rgb(224,224,224);
}
.container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>